<template>
    <transition name="modal-fade">
        <div v-if="isdisplay" class="modal-overlay" @click.self="close">
            <div class="modal-container">
                <!-- Header -->
                <header class="modal-header">
                    <div class="head-main">
                        <span class="head-icon"><i class="ri-archive-2-line"></i></span>
                        <div class="header-content">
                            <h2 class="modal-title">{{ titlemodal }}</h2>
                            <p class="modal-subtitle">Gestion des articles</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="btn-close" aria-label="Fermer">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M18 6L6 18M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </header>

                <!-- Alerts -->
                <div v-if="messagesucces" class="alert alert-success">
                    <svg class="alert-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke-linecap="round"/>
                        <polyline points="22 4 12 14.01 9 11.01" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>{{ messagesucces }}</span>
                </div>

                <div v-if="messageerror" class="alert alert-error">
                    <svg class="alert-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="12" y1="8" x2="12" y2="12"/>
                        <line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    <span>{{ messageerror }}</span>
                </div>

                <!-- Navigation Tabs -->
                <nav class="tabs-navigation">
                    <div class="tabs-scroll">
                        <button
                                v-for="(tab, index) in tabs"
                                :key="index"
                                @click="activeTab = tab.id"
                                :class="['tab-btn', { 'active': activeTab === tab.id }]"
                        >
                            <span class="tab-icon">{{ tab.icon }}</span>
                            <span class="tab-label">{{ tab.label }}</span>
                        </button>
                    </div>
                </nav>

                <!-- Body Content -->
                <main class="modal-body">
                    <!-- Tab 1: Information de base -->
                    <section v-show="activeTab === 'base'" class="tab-content">
                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">📦</span>
                                Informations générales
                            </h3>

                            <div class="form-group">
                                <label class="form-label required">Intitulé de l'article</label>
                                <input
                                        v-model="Items.libelle"
                                        type="text"
                                        class="form-input"
                                        placeholder="Ex: Coca-Cola 33cl"
                                >
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label class="form-label">Destination</label>
                                    <div class="select-wrapper">
                                        <select v-model="Items.datajsonarticles.destination" class="form-select">
                                            <option value="ACHAT">Achat</option>
                                            <option value="VENTE">Vente</option>
                                            <option value="ACHAT_ET_VENTE">Achat et Vente</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Suivi de stock</label>
                                    <div class="toggle-container">
                                        <button
                                                @click="Items.suividestock = Items.suividestock == 1 ? 0 : 1"
                                                :class="['toggle-btn', { 'active': Items.suividestock == 1 }]"
                                                :disabled="checkusearticle"
                                        >
                      <span class="toggle-track">
                        <span class="toggle-thumb"></span>
                      </span>
                                            <span class="toggle-text">{{ Items.suividestock == 1 ? 'Oui' : 'Non' }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">🏷️</span>
                                Classification
                            </h3>

                            <div class="form-row">
                                <div class="form-group">
                                    <label class="form-label">Unité</label>
                                    <div class="input-action-group">
                                        <input
                                                :value="Items.datajsonarticles.unite ? Items.datajsonarticles.unite.name : ''"
                                                type="text"
                                                class="form-input"
                                                placeholder="Sélectionner une unité"
                                                readonly
                                        >
                                        <button @click="btnmodalfichierdebase('unite')" class="btn-icon">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <circle cx="11" cy="11" r="8"/>
                                                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Catalogue</label>
                                    <div class="input-action-group">
                                        <input
                                                :value="Items.datajsonarticles.catalogue ? Items.datajsonarticles.catalogue.name : ''"
                                                type="text"
                                                class="form-input"
                                                placeholder="Sélectionner un catalogue"
                                                readonly
                                        >
                                        <button @click="btnmodalfichierdebase('cat')" class="btn-icon">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <circle cx="11" cy="11" r="8"/>
                                                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label class="form-label">Fiche technique</label>
                                    <div class="radio-group">
                                        <label class="radio-item">
                                            <input type="radio" :value="1" v-model="Items.datajsonarticles.fichetechnique" :disabled="checkusearticle">
                                            <span class="radio-mark"></span>
                                            <span>Autorisée</span>
                                        </label>
                                        <label class="radio-item">
                                            <input type="radio" :value="0" v-model="Items.datajsonarticles.fichetechnique" :disabled="checkusearticle">
                                            <span class="radio-mark"></span>
                                            <span>Non autorisée</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Type d'article</label>
                                    <div class="chip-group">
                                        <button
                                                @click="Items.datajsonarticles.typearticle = 'Article'"
                                                :class="['chip', { 'active': Items.datajsonarticles.typearticle === 'Article' }]"
                                        >Article</button>
                                        <button
                                                @click="Items.datajsonarticles.typearticle = 'matierspremiere'"
                                                :class="['chip', { 'active': Items.datajsonarticles.typearticle === 'matierspremiere' }]"
                                        >Matière première</button>
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label class="form-label">Périsable</label>
                                    <div class="toggle-container">
                                        <button
                                                @click="Items.datajsonarticles.perisable = Items.datajsonarticles.perisable === 'true' ? 'false' : 'true'"
                                                :class="['toggle-btn', { 'active': Items.datajsonarticles.perisable === 'true' }]"
                                        >
                                            <span class="toggle-track"><span class="toggle-thumb"></span></span>
                                            <span class="toggle-text">{{ Items.datajsonarticles.perisable === 'true' ? 'Oui' : 'Non' }}</span>
                                        </button>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">En sommeil</label>
                                    <div class="toggle-container">
                                        <button
                                                @click="Items.datajsonarticles.ensommeil = Items.datajsonarticles.ensommeil === 'true' ? 'false' : 'true'"
                                                :class="['toggle-btn warning', { 'active': Items.datajsonarticles.ensommeil === 'true' }]"
                                        >
                                            <span class="toggle-track"><span class="toggle-thumb"></span></span>
                                            <span class="toggle-text">{{ Items.datajsonarticles.ensommeil === 'true' ? 'Oui' : 'Non' }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">📦</span>
                                Emballage & Code barre
                            </h3>

                            <div class="form-row">
                                <div class="form-group">
                                    <label class="form-label">Suivi d'emballage</label>
                                    <div class="select-wrapper">
                                        <select v-model="Items.datajsonarticles.paramdindication.param3.suiviedemballage" :disabled="checkusearticle" class="form-select">
                                            <option value="Non">Non</option>
                                            <option value="Oui">Oui</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Emballage</label>
                                    <div class="input-action-group">
                                        <input
                                                :value="Items.datajsonarticles.paramdindication.param3.emballage ? Items.datajsonarticles.paramdindication.param3.emballage.name : ''"
                                                type="text"
                                                class="form-input"
                                                placeholder="Sélectionner un emballage"
                                                readonly
                                        >
                                        <button
                                                @click="btnmodalfichierdebase('emballage')"
                                                class="btn-icon"
                                                :disabled="checksuiviedemballage"
                                        >
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <circle cx="11" cy="11" r="8"/>
                                                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label">Code barre</label>
                                <input
                                        v-model="Items.reference"
                                        type="text"
                                        class="form-input"
                                        placeholder="Ex: 3760017912345"
                                >
                            </div>
                        </div>
                    </section>

                    <!-- Tab 2: Taxe, TVA -->
                    <section v-show="activeTab === 'taxe'" class="tab-content">
                        <div class="info-banner">
                            <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <circle cx="12" cy="12" r="10"/>
                                <line x1="12" y1="16" x2="12" y2="12"/>
                                <line x1="12" y1="8" x2="12.01" y2="8"/>
                            </svg>
                            <p>Si la TVA n'est pas applicable à cet article, veuillez sélectionner la Taxe d'imposition qui convient.</p>
                        </div>

                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">💰</span>
                                Tarification
                            </h3>

                            <div class="form-row form-row-3">
                                <div class="form-group">
                                    <label class="form-label">Prix d'achat</label>
                                    <div class="input-currency">
                                        <input
                                                v-model="Items.datajsonarticles.tarification.prixachat"
                                                type="number"
                                                min="0"
                                                class="form-input"
                                                placeholder="0"
                                        >
                                        <span class="currency">FCFA</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Type de prix</label>
                                    <div class="select-wrapper">
                                        <select @change="onChange($event)" v-model="Items.datajsonarticles.tarification.typeprixvente" class="form-select">
                                            <option value="1">Prix TTC</option>
                                            <option value="0">Prix HT</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">TVA applicable</label>
                                    <div class="toggle-container">
                                        <button
                                                @click="Items.datajsonarticles.tptva = Items.datajsonarticles.tptva == 1 ? 0 : 1"
                                                :class="['toggle-btn', { 'active': Items.datajsonarticles.tptva == 1 }]"
                                                :disabled="checkusearticle"
                                        >
                                            <span class="toggle-track"><span class="toggle-thumb"></span></span>
                                            <span class="toggle-text">{{ Items.datajsonarticles.tptva == 1 ? 'Oui' : 'Non' }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">📋</span>
                                Imposition
                            </h3>

                            <div class="form-row form-row-3">
                                <div class="form-group">
                                    <label class="form-label">Taxe d'imposition</label>
                                    <div class="select-wrapper">
                                        <select v-model="Items.datajsonarticles.normalisation.taxedimposition" class="form-select">
                                            <option value="A">Exonéré</option>
                                            <option value="B">Taxable (18%)</option>
                                            <option value="C">Export produits taxable</option>
                                            <option value="D">TVA régime exception</option>
                                            <option value="E">Régime fiscal TPS</option>
                                            <option value="F">Réservé (taxe séjour)</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Taux d'imposition</label>
                                    <div class="input-currency">
                                        <input
                                                :value="taxedimposition"
                                                type="text"
                                                class="form-input"
                                                disabled
                                        >
                                        <span class="currency">%</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Taxe spécifique</label>
                                    <input
                                            v-model="Items.datajsonarticles.normalisation.tauxtaxespecifique"
                                            type="text"
                                            class="form-input"
                                            placeholder="0"
                                    >
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label">Description du TS appliqué</label>
                                <input
                                        v-model="Items.datajsonarticles.normalisation.descriptiondutsapplique"
                                        type="text"
                                        class="form-input"
                                        placeholder="Description de la taxe spécifique..."
                                >
                            </div>
                        </div>
                    </section>

                    <!-- Tab 3: Prix de vente -->
                    <section v-show="activeTab === 'prix'" class="tab-content">
                        <div class="info-banner">
                            <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M3 3h18v18H3z"/>
                                <path d="M21 9H3M21 15H3M9 21V3"/>
                            </svg>
                            <p>Mise à jour des prix de vente par entrepôt / dépôt</p>
                        </div>

                        <div class="table-wrapper">
                            <div class="table-scroll">
                                <table class="data-table">
                                    <thead>
                                    <tr>
                                        <th class="sticky-col">Entrepôt</th>
                                        <th>Prix achat</th>
                                        <th>Stock min</th>
                                        <th>Stock max</th>
                                        <th>Prix vente</th>
                                        <th>{{ datainputlibelleforms.prixvente1 }}</th>
                                        <th>{{ datainputlibelleforms.prixvente2 }}</th>
                                        <th>{{ datainputlibelleforms.prixvente3 }}</th>
                                        <th>{{ datainputlibelleforms.prixvente4 }}</th>
                                        <th>{{ datainputlibelleforms.prixvente5 }}</th>
                                        <th>{{ datainputlibelleforms.prixvente6 }}</th>
                                        <th>{{ datainputlibelleforms.prixvente7 }}</th>
                                        <th>Tarifs</th>
                                        <th>Sélection</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(datavalue, index) in jsonarticles" :key="index" :class="{ 'row-new': datavalue.pidligne === '' }">
                                        <td class="sticky-col">
                                            <span class="cell-entrepot">{{ datavalue.mg.name }}</span>
                                        </td>
                                        <td><span class="cell-value">{{ datavalue.pa }}</span></td>
                                        <td>
                                            <input v-model.number="datavalue.stockminimum" type="number" class="table-input">
                                        </td>
                                        <td>
                                            <input v-model.number="datavalue.stockmaximum" type="number" class="table-input">
                                        </td>
                                        <td>
                                            <input v-model.number="datavalue.pu" type="number" class="table-input highlight">
                                        </td>
                                        <td><input v-model.number="datavalue.pu1" type="number" class="table-input"></td>
                                        <td><input v-model.number="datavalue.pu2" type="number" class="table-input"></td>
                                        <td><input v-model.number="datavalue.pu3" type="number" class="table-input"></td>
                                        <td><input v-model.number="datavalue.pu4" type="number" class="table-input"></td>
                                        <td><input v-model.number="datavalue.pu5" type="number" class="table-input"></td>
                                        <td><input v-model.number="datavalue.pu6" type="number" class="table-input"></td>
                                        <td><input v-model.number="datavalue.pu7" type="number" class="table-input"></td>
                                        <td>
                                            <div class="tarif-list">
                                                <div v-for="(tarif, ti) in (datavalue.pv || [])" :key="ti" class="tarif-row">
                                                    <span class="tarif-label">
                                                        {{ datainputlibelleforms[tarif.mtyprix] || tarif.mtyprix }}
                                                    </span>
                                                    <span class="tarif-price">{{ tarif.pu }} F</span>
                                                    <span v-if="tarif.min || tarif.max" class="tarif-range">
                                                        ({{ tarif.min || 0 }} - {{ tarif.max || '∞' }})
                                                    </span>
                                                    <button @click="deleteTarif(index, ti)" type="button" class="tarif-delete" title="Supprimer">
                                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                            <polyline points="3 6 5 6 21 6"/>
                                                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div v-if="!datavalue.pv || !datavalue.pv.length" class="tarif-empty">Aucun tarif</div>
                                            </div>
                                            <button @click="btnmodalgestiontarifdevente(datavalue.pv, index, 'add')" type="button" class="tarif-add">
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                    <line x1="12" y1="5" x2="12" y2="19"/>
                                                    <line x1="5" y1="12" x2="19" y2="12"/>
                                                </svg>
                                                <span>Ajouter</span>
                                            </button>
                                        </td>
                                        <td>
                                            <label class="checkbox-wrapper">
                                                <input
                                                        type="checkbox"
                                                        v-model="datavalue.selected"
                                                        :disabled="datavalue.pidligne !== ''"
                                                >
                                                <span class="checkmark"></span>
                                                <span class="checkbox-text">{{ datavalue.pidligne === '' ? 'Nouveau' : 'Existant' }}</span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr v-if="!jsonarticles.length">
                                        <td colspan="14" class="empty-cell">
                                            <div class="empty-state">
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                                                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                                                    <line x1="8" y1="21" x2="16" y2="21"/>
                                                    <line x1="12" y1="17" x2="12" y2="21"/>
                                                </svg>
                                                <p>Aucun enregistrement trouvé</p>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </section>

                    <!-- Tab 4: Compte comptable -->
                    <section v-show="activeTab === 'compte'" class="tab-content">
                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">📊</span>
                                Comptes de vente
                            </h3>

                            <div class="form-group">
                                <label class="form-label">Compte de vente local</label>
                                <div class="input-action-group">
                                    <input
                                            :value="Items.datajsonarticles.comptetva.compteventelocal ? Items.datajsonarticles.comptetva.compteventelocal.numero + ' - ' + Items.datajsonarticles.comptetva.compteventelocal.libelle : ''"
                                            type="text"
                                            class="form-input"
                                            placeholder="Sélectionner un compte de vente local"
                                            readonly
                                    >
                                    <button @click="btnmodalcompta('ventelocal')" class="btn-icon">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <circle cx="11" cy="11" r="8"/>
                                            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label">Compte de vente export</label>
                                <div class="input-action-group">
                                    <input
                                            :value="Items.datajsonarticles.comptetva.compteventeexport ? Items.datajsonarticles.comptetva.compteventeexport.numero + ' - ' + Items.datajsonarticles.comptetva.compteventeexport.libelle : ''"
                                            type="text"
                                            class="form-input"
                                            placeholder="Sélectionner un compte de vente export"
                                            readonly
                                    >
                                    <button @click="btnmodalcompta('venteexport')" class="btn-icon">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <circle cx="11" cy="11" r="8"/>
                                            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- Tab 5: Paramètres d'indication -->
                    <section v-show="activeTab === 'info'" class="tab-content">
                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">⚙️</span>
                                Paramètres
                            </h3>

                            <div class="form-group">
                                <label class="form-label">Paramètre d'indication</label>
                                <div class="select-wrapper">
                                    <select v-model="Items.datajsonarticles.paramdindication.param" :disabled="checkusearticle" class="form-select">
                                        <option :value="null">Sélectionner un paramètre</option>
                                        <option v-for="(datavalue, index) of otherdata.paramcom" :key="index" :value="datavalue">
                                            {{ datavalue.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">📍</span>
                                Emplacement en magasin
                            </h3>

                            <div class="form-row">
                                <div class="form-group">
                                    <label class="form-label">Rayon</label>
                                    <input
                                        v-model="Items.datajsonarticles.emplacement.rayon"
                                        type="text"
                                        class="form-input"
                                        placeholder="A, B, C…"
                                    >
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Couloir</label>
                                    <input
                                        v-model="Items.datajsonarticles.emplacement.couloir"
                                        type="text"
                                        class="form-input"
                                        placeholder="1, 2, 3…"
                                    >
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Étagère</label>
                                    <input
                                        v-model="Items.datajsonarticles.emplacement.etagere"
                                        type="text"
                                        class="form-input"
                                        placeholder="Haute, Basse…"
                                    >
                                </div>
                            </div>
                        </div>

                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">📝</span>
                                Informations libres
                            </h3>

                            <div class="form-group">
                                <label class="form-label">Information libre</label>
                                <input
                                        v-model="Items.datajsonarticles.information.info"
                                        type="text"
                                        class="form-input"
                                        placeholder="Information complémentaire..."
                                >
                            </div>

                            <div class="form-group">
                                <label class="form-label">Information libre 1</label>
                                <input
                                        v-model="Items.datajsonarticles.information.info1"
                                        type="text"
                                        class="form-input"
                                        placeholder="Information complémentaire..."
                                >
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label class="form-label">Information libre 2</label>
                                    <input
                                            v-model="Items.datajsonarticles.information.info2"
                                            type="text"
                                            class="form-input"
                                            placeholder="..."
                                    >
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Information libre 3</label>
                                    <input
                                            v-model="Items.datajsonarticles.information.info3"
                                            type="text"
                                            class="form-input"
                                            placeholder="..."
                                    >
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- Tab 6: Restaurant -->
                    <section v-show="activeTab === 'restaurant'" class="tab-content">
                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">🏷️</span>
                                Catégorie
                            </h3>

                            <div class="form-group">
                                <label class="form-label">Catégorie du plat</label>
                                <select v-model="Items.articlesenrestaurant.categorieplat" class="form-select">
                                    <option value="PLAT">PLAT</option>
                                    <option value="BOISSON">BOISSON</option>
                                    <option value="DESSERT">DESSERT</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-section">
                            <h3 class="section-title">
                                <span class="section-icon">🍽️</span>
                                Accompagnements
                            </h3>

                            <div class="accompagnement-add">
                                <div class="select-wrapper flex-grow">
                                    <select v-model="selectaccompagnement" class="form-select">
                                        <option :value="null">Sélectionner un accompagnement</option>
                                        <option v-for="(vline, index) in otherdata.accompagnement" :key="index" :value="vline">
                                            {{ vline.name }}
                                        </option>
                                    </select>
                                </div>
                                <button @click="btnajoutaccompagnement" class="btn-add">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <line x1="12" y1="5" x2="12" y2="19"/>
                                        <line x1="5" y1="12" x2="19" y2="12"/>
                                    </svg>
                                    <span>Ajouter</span>
                                </button>
                            </div>

                            <ul class="accompagnement-list">
                                <li v-for="(datavalue, j) in dataaccompagnement" :key="datavalue.pid" class="accompagnement-item">
                                    <span class="accompagnement-name">{{ datavalue.name }}</span>
                                    <button @click="removeline(j)" class="btn-remove">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <polyline points="3 6 5 6 21 6"/>
                                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                                        </svg>
                                    </button>
                                </li>
                            </ul>

                            <div v-if="!dataaccompagnement.length" class="empty-accompagnement">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                    <line x1="3" y1="9" x2="21" y2="9"/>
                                    <line x1="9" y1="21" x2="9" y2="9"/>
                                </svg>
                                <p>Aucun accompagnement ajouté</p>
                            </div>
                        </div>
                    </section>
                </main>

                <!-- Footer -->
                <footer class="modal-footer">
                    <button @click="close" type="button" class="btn btn-cancel">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <line x1="18" y1="6" x2="6" y2="18"/>
                            <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                        <span>Fermer</span>
                    </button>
                    <button v-if="typeaction === 'add'" @click="saveItems" class="btn btn-save">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                            <polyline points="17 21 17 13 7 13 7 21"/>
                            <polyline points="7 3 7 8 15 8"/>
                        </svg>
                        <span>Enregistrer</span>
                    </button>
                    <button v-if="typeaction === 'update'" @click="updateItems" class="btn btn-save">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                        </svg>
                        <span>Modifier</span>
                    </button>
                </footer>
            </div>
        </div>
    </transition>

    <!-- Sub-modals -->
    <modaltarificationstock @elementSelectionnetarificationstock="handleElementSelectionnetarificationstock" ref="modaltarificationstock"></modaltarificationstock>
    <modalfichierdebase @elementSelectionnefichierdebase="handleElementSelectionnefichierdebase" ref="modalfichierdebase"></modalfichierdebase>
    <modalcompta @elementSelectionnecompta="handleElementSelectionnecompta" ref="modalcompta"></modalcompta>
    <modalgestiontarifdevente @elementSelectionnegestiontarifdevente="handleElementSelectionnegestiontarifdevente" ref="modalgestiontarifdevente"></modalgestiontarifdevente>
    <modalmodifcationtarifentrepot @elementSelectionnemodifcationtarifentrepot="handleElementSelectionnemodifcationtarifentrepot" ref="modalmodifcationtarifentrepot"></modalmodifcationtarifentrepot>
</template>

<script>
    import {cloneobjet, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import modaltarificationstock from "@/components/views/pages/stock/articles/modal_tarificationstock";
    import modalfichierdebase from "@/components/views/pages/stock/articles/modal_fichierdebase";
    import modalcompta from "@/components/views/pages/stock/articles/modal_compta";
    import modalgestiontarifdevente from "@/components/views/pages/stock/articles/modal_gestiontarifdevente";
    import modalmodifcationtarifentrepot from "@/components/views/pages/stock/articles/modal_modifcationtarifentrepot";
    const axios = require('axios');

    export default {
        /* eslint-disable */
        name: "modalform",

        components: {
            modaltarificationstock,
            modalcompta,
            modalgestiontarifdevente,
            modalmodifcationtarifentrepot,
            modalfichierdebase
        },

        data() {
            return {
                isdisplay: false,
                messageerror: "",
                messagesucces: "",
                titlemodal: "",
                typedoc: "",
                typeaction: "add",
                Items: {},
                activeTab: 'base',

                tabs: [
                    { id: 'base', label: 'Informations', icon: '📋' },
                    { id: 'taxe', label: 'Taxe, TVA', icon: '💰' },
                    { id: 'prix', label: 'Prix', icon: '🏷️' },
                    { id: 'compte', label: 'Comptabilité', icon: '📊' },
                    { id: 'info', label: 'Paramètres', icon: '⚙️' },
                    { id: 'restaurant', label: 'Restaurant', icon: '🍽️' }
                ],

                nbremg: false,
                datainputlibelleforms: [],
                alldata: [],
                listefrs: [],
                jsonaccompagnement: [],
                defaultjsonarticles: [],
                jsonarticles: [],
                newsjsonarticles: [],
                createdatapv: [],
                datapv: [],
                mdataclose: [],
                mypv: {},
                indexpv: '',
                selectaccompagnement: null,
                dataaccompagnement: [],
                activecolums1: false,
                activecolums2: false,
                activecolums3: false,
                activecolums4: false,
                activecolums5: false,
                activecolums6: false,
                activecolums7: false,
                activecolums8: true,
                otherdata: []
            };
        },

        computed: {
            disabledidunitettc() {
                let typeprixvente = this.Items.datajsonarticles.tarification.typeprixvente + 1;
                return typeprixvente <= 1;
            },

            useItem() {
                return this.Items.usear !== 0;
            },

            checkusearticle() {
                return this.Items.nbreusearticle > 0;
            },

            checksuiviedemballage() {
                if (this.Items.nbreusearticle > 0) return true;

                if (this.Items.datajsonarticles.paramdindication.param3.suiviedemballage === "Non") {
                    this.Items.datajsonarticles.paramdindication.param3.emballage = null;
                    this.Items.datajsonarticles.paramdindication.param3.typeoperation = 'default';
                    return true;
                }

                this.Items.datajsonarticles.paramdindication.param3.typeoperation = 'endetail';
                return false;
            },

            checkVal() {
                return this.Items.pid !== "";
            },

            taxedimposition() {
                if (this.Items.datajsonarticles.normalisation.taxedimposition === "B" ||
                    this.Items.datajsonarticles.normalisation.taxedimposition === "D") {
                    this.Items.datajsonarticles.normalisation.tauxtaxedimposition = 0.18;
                    this.Items.datajsonarticles.tptva = 1;
                } else {
                    this.Items.datajsonarticles.normalisation.tauxtaxedimposition = 0;
                    this.Items.datajsonarticles.tptva = 0;
                }
                return this.Items.datajsonarticles.normalisation.tauxtaxedimposition;
            },

            disabledstockminimum() {
                if (parseFloat(this.Items.suividestock) === 0) {
                    if (this.Items.pid === "") this.Items.datajsonarticles.stockminimum = 0;
                    return true;
                }

                if (["ACHAT", "ACHAT_ET_VENTE", "VENTE"].includes(this.Items.datajsonarticles.destination)) {
                    if (this.Items.pid === "") this.Items.datajsonarticles.stockminimum = 0;
                    return false;
                }

                if (this.Items.pid === "") this.Items.datajsonarticles.stockminimum = 0;
                return true;
            }
        },

        methods: {
            removeline(index) {
                this.dataaccompagnement.splice(index, 1);
            },

            btnajoutaccompagnement() {
                if (this.selectaccompagnement === null) return;

                const exists = this.dataaccompagnement.some(item => item.pid === this.selectaccompagnement.pid);

                if (!exists) {
                    this.dataaccompagnement.push(this.selectaccompagnement);
                    this.selectaccompagnement = null;
                } else {
                    toastr['error']('Cet accompagnement existe déjà dans la liste.', "<b></b>");
                }
            },

            btnmodaltarificationstock() {
                if (this.Items.datajsonarticles.magasin === null) {
                    toastr['error']("Veuillez sélectionner l'entrepôt principal (Onglet Général)", "<b></b>");
                    return;
                }

                this.$refs.modaltarificationstock.show(
                    "",
                    this.otherdata.magasin,
                    this.datainputlibelleforms,
                    this.Items.datajsonarticles.tarification.prixachat,
                    this.jsonarticles,
                    this.newsjsonarticles
                );
            },

            handleElementSelectionnetarificationstock(elementSelectionne) {
                if (elementSelectionne.typ === "add") {
                    this.jsonarticles.push(elementSelectionne.value);
                    this.newsjsonarticles.push(elementSelectionne.value);
                }
            },

            handleElementSelectionnefichierdebase(elementSelectionne) {
                if (elementSelectionne.typ === "unite") {
                    this.Items.datajsonarticles.unite = elementSelectionne.value;
                    this.otherdata.unite = elementSelectionne.datatable;
                }
                if (elementSelectionne.typ === "cat") {
                    this.Items.datajsonarticles.catalogue = elementSelectionne.value;
                    this.otherdata.catalogue = elementSelectionne.datatable;
                }
                if (elementSelectionne.typ === "emballage") {
                    this.Items.datajsonarticles.paramdindication.param3.emballage = elementSelectionne.value;
                    this.otherdata.emballage = elementSelectionne.datatable;
                }
            },

            btnmodalfichierdebase(typ) {
                let listedatable = [];
                let titlemodal = "";

                if (typ === "emballage") {
                    listedatable = this.otherdata.emballage;
                    titlemodal = "Liste des emballages";
                }
                if (typ === "unite") {
                    listedatable = this.otherdata.unite;
                    titlemodal = "Liste des unités";
                }
                if (typ === "cat") {
                    listedatable = this.otherdata.catalogue;
                    titlemodal = "Liste des catalogues";
                }

                this.$refs.modalfichierdebase.show(titlemodal, listedatable, typ);
            },

            handleElementSelectionnecompta(elementSelectionne) {
                if (elementSelectionne.typ === "ventelocal") {
                    this.Items.datajsonarticles.comptetva.compteventelocal = elementSelectionne.value;
                }
                if (elementSelectionne.typ === "venteexport") {
                    this.Items.datajsonarticles.comptetva.compteventeexport = elementSelectionne.value;
                }
            },

            btnmodalcompta(typ) {
                let listedatable = typ === "ventelocal" ? this.otherdata.compteventelocal : this.otherdata.compteventeexport;
                this.$refs.modalcompta.show("Plan comptable", listedatable, typ);
            },

            handleElementSelectionnegestiontarifdevente(elementSelectionne) {
                if (elementSelectionne.typ === "add") {
                    this.jsonarticles[elementSelectionne.index].pv = elementSelectionne.value;
                }
                if (elementSelectionne.typ === "create") {
                    this.createdatapv = elementSelectionne.value;
                }
            },

            btnmodalgestiontarifdevente(datapv, index, btnaction) {
                this.$refs.modalgestiontarifdevente.show("GESTION DES TARIFS DE VENTE", this.datainputlibelleforms, datapv, index, btnaction);
            },

            deleteTarif(rowIndex, tarifIndex) {
                this.jsonarticles[rowIndex].pv.splice(tarifIndex, 1);
            },

            handleElementSelectionnemodifcationtarifentrepot(elementSelectionne) {
                this.jsonarticles[elementSelectionne.index] = elementSelectionne.value;
            },

            modifierpu(value, index) {
                this.$refs.modalmodifcationtarifentrepot.show(
                    "MODIFICATION DES TARIFICATIONS ET STOCK : " + value.mg.name,
                    this.datainputlibelleforms,
                    value,
                    index
                );
            },

            close() {
                this.isdisplay = false;
                this.$emit('closed');
            },

            show(titlemodal, typeaction, mItems, datainputlibelleforms, otherdata, jsonarticles = [], dataaccompagnement = []) {
                this.titlemodal = titlemodal;
                this.typeaction = typeaction;
                this.Items = mItems;

                if (!this.Items.articlesenrestaurant) {
                    this.Items.articlesenrestaurant = { accompagnement: [], categorieplat: 'PLAT' };
                } else if (!this.Items.articlesenrestaurant.categorieplat) {
                    this.Items.articlesenrestaurant.categorieplat = 'PLAT';
                }

                this.selectaccompagnement = null;
                this.jsonarticles = [...jsonarticles];
                this.defaultjsonarticles =cloneobjet(jsonarticles);
                this.datainputlibelleforms = datainputlibelleforms;
                this.otherdata = otherdata;
                this.dataaccompagnement = dataaccompagnement;
                this.messagesucces = "";
                this.messageerror = "";
                this.jsonaccompagnement = [];
                this.activeTab = 'base';
                this.isdisplay = true;
            },

            async saveItems() {
                this.$store.dispatch('lancerchargement', true);

                if (this.Items.unite === null || this.Items.libelle === "") {
                    this.$store.dispatch('lancerchargement', false);
                    toastr['error']("Veuillez saisir toutes les informations (le nom de l'article, l'unité de comptage)", "<b></b>");
                    return;
                }

                let valuejsonarticles = [];
                if (Array.isArray(this.jsonarticles) && this.jsonarticles.length > 0) {
                    const prixAchat = this.Items?.datajsonarticles?.tarification?.prixachat || 0;
                    valuejsonarticles = this.jsonarticles.map(item => ({ ...item, pa: prixAchat }));
                }

                this.newsjsonarticles = valuejsonarticles.filter(item => item.selected);
                this.Items.jsonarticles = valuejsonarticles;
                this.Items.newsjsonarticles = this.newsjsonarticles;
                this.Items.articlesenrestaurant.accompagnement = this.dataaccompagnement;

                const t = this;
                const url = process.env.VUE_APP_API_URL + '/egl745874pstock771714dfe/ar/add/' + this.$store.state.appsociete + '/' + randomString();

                try {
                    const res = await axios.post(url, this.Items, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    t.$store.dispatch('lancerchargement', false);

                    if (res.data.success) {
                        t.Items.pid = res.data.mkey;
                        t.Items.codebarre = res.data.kref;

                        t.Items.perisable = (t.Items.perisable === "false" || t.Items.perisable === false) ? "Non" : "Oui";

                        const taxeMapping = {
                            "A": "Exonéré", "B": "Taxable (18%)", "E": "Régime fiscal TPS",
                            "D": "TVA régime d'exception", "C": "Exportation de produits taxable"
                        };
                        t.Items.taxedimposition = taxeMapping[t.Items.datajsonarticles.normalisation.taxedimposition] || "";

                        t.mdataclose.push(t.Items);
                        t.resetForm();
                        toastr['success'](res.data.message, "<b></b>");
                    } else {
                        t.handleError(res.data);
                    }
                } catch (error) {
                    toastr['error']("Une erreur est subvenue. Veuillez contacter votre administrateur.", "<b></b>");
                } finally {
                    this.$store.dispatch('lancerchargement', false);
                }
            },

            async updateItems() {
                this.$store.dispatch('lancerchargement', true);

                if (this.Items.unite === null || this.Items.libelle === "") {
                    this.$store.dispatch('lancerchargement', false);
                    toastr['error']("Veuillez saisir toutes les informations (le nom de l'article, l'unité de comptage)", "<b></b>");
                    return;
                }

                let valuejsonarticles = [];
                if (Array.isArray(this.jsonarticles) && this.jsonarticles.length > 0) {
                    const prixAchat = this.Items?.datajsonarticles?.tarification?.prixachat || 0;
                    valuejsonarticles = this.jsonarticles.map(item => ({ ...item, pa: prixAchat }));
                }

                const selectedItems = valuejsonarticles.filter(item => item.selected);
                this.jsonarticles = selectedItems;
                this.newsjsonarticles = selectedItems;
                this.Items.jsonarticles = this.jsonarticles;
                this.Items.newsjsonarticles = this.newsjsonarticles;
                this.Items.articlesenrestaurant = {
                    accompagnement: this.dataaccompagnement,
                    categorieplat: this.Items.articlesenrestaurant?.categorieplat || 'PLAT'
                };

                const t = this;
                const url = process.env.VUE_APP_API_URL + '/egl745874pstock771714dfe/ar/maj/' + this.$store.state.appsociete + '/' + randomString();

                try {
                    const res = await axios.post(url, this.Items, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    t.$store.dispatch('lancerchargement', false);

                    if (res.data.success) {
                        t.messagesucces = res.data.message;
                        toastr['success'](t.messagesucces, "<b></b>");
                        t.close();
                    } else {
                        t.handleError(res.data);
                    }
                } catch (error) {
                    toastr['error']("Une erreur est subvenue. Veuillez contacter votre administrateur.", "<b>Erreur</b>");
                } finally {
                    this.$store.dispatch('lancerchargement', false);
                }
            },

            handleError(data) {
                this.messageerror = "";
                this.messagesucces = "";

                if (data.datamessage && data.datamessage.length > 0) {
                    this.messageerror = data.datamessage.join(", ");
                } else {
                    this.messageerror = data.message;
                }
                toastr['error'](this.messageerror, "<b></b>");
            },

            resetForm() {
                this.Items = {
                    pid: '', libelle: '', reference: '', suividestock: 0, articletype: 0,
                    nbreusearticle: 0, usear: 0, stockminimum: 0, lignetitre: '',
                    lignedescription: '', lignedescriptiontotal: '', lignephotodegarde: '',
                    lignesommeil: '', lignein_stock: '', lignecategorie: '', lignesous_categorie: '',
                    lignemontant: '', ligneremise: '', lignenbredevue: '', ligneboutique: '', ligneboutiquepid: '',
                    datajsonarticles: {
                        typearticle: "Article", destination: "ACHAT_ET_VENTE", perisable: false,
                        ensommeil: false, tptva: 1, fichetechnique: 0, stockminimum: 0, stockmaximum: 0,
                        magasin: null, unite: null, catalogue: null,
                        comptetva: { compteventeexport: null, comptefacturation: null, compteventelocal: null },
                        normalisation: { taxedimposition: "E", tauxtaxedimposition: null, tauxtaxespecifique: null, descriptiondutsapplique: null },
                        tarification: { prixvente1: 0, prixvente2: 0, prixvente3: 0, prixvente4: 0, prixvente5: 0, prixvente6: 0, prixvente7: 0, prixachat: 0, prixvente: 0, typeprixvente: 1, prixpromo: 0, typttc: 1.18 },
                        information: { info: '', info1: '', info2: '', info3: '' },
                        emplacement: { rayon: '', couloir: '', etagere: '' },
                        paramdindication: { param: null, param1: null, param2: [], param3: { suiviedemballage: 'Non', typeoperation: 'default', emballage: null } }
                    },
                    articlesenligne: { titreenligne: '...', montantenligne: 0, montantremiseenligne: 0,
                     minidescriptionenligne: '...', totaldescriptionenligne: '...', categorieenligne: null,
                      souscategorieenligne: null, lesphotosenligne: [], articledisponible: true, miseenligne: false },
                     articlesenrestaurant: {
                        accompagnement: [],
                        categorieplat:'PLAT'
                    },
                    articlesclinique: {}
                };

                this.createdatapv = [];
                this.datapv = [];
                this.mypv = {};
                this.jsonarticles = this.defaultjsonarticles;
                this.newsjsonarticles = [];
                this.dataaccompagnement = [];
            },

            onChange(event) {
                // Logic for price type change
            },

            retirerselectedmagasin(index, mgp, bd, pid) {
                if (bd === 1) {
                    toastr['error']("Impossible de retirer cet entrepôt.", "<b></b>");
                    return;
                }
                if (bd === 1 && mgp === 1) {
                    toastr['error']("Impossible de retirer cet entrepôt.", "<b></b>");
                    return;
                }
                if (bd === 0 && mgp === 1) this.addpumagasinprincipal = 0;

                this.jsonarticles.splice(index, 1);
                this.newsjsonarticles = this.newsjsonarticles.filter(post => post.mg.pid !== pid);
            },

            retirerselectedpv(index, value) {
                value.splice(index, 1);
            }
        }
    };
</script>

<style scoped>
    /* ========================================
       Variables CSS - Design System
       ======================================== */
    .modal-overlay {
        /* Charte cf-/ds- : palette de marque Ynex (#845ADF) + neutres cf.
           NB : --primary/--success/--danger/--warning portent le MÊME nom que
           les tokens globaux (triplets) → on ne peut pas faire rgb(var(--primary))
           ici (auto-référence) : on pose donc les valeurs littérales de la charte.
           Les neutres/rayons/ombre pointent vers les tokens cf (noms distincts). */
        --primary: #845ADF;
        --primary-hover: #7349cc;
        --primary-light: #ece7fb;
        --success: #26bf94;
        --success-light: #d7f5ec;
        --danger: #e6533c;
        --danger-light: #fdecea;
        --warning: #f5b849;
        --bg-primary: #ffffff;
        --bg-secondary: var(--cf-surface);
        --bg-tertiary: var(--cf-surface-alt);
        --text-primary: var(--cf-ink-strong);
        --text-secondary: var(--cf-muted);
        --text-muted: var(--cf-faint);
        --border: var(--cf-border);
        --shadow: var(--cf-shadow-md);
        --radius: var(--cf-radius);
        --radius-sm: var(--cf-radius-sm);
    }

    /* ========================================
       Modal Overlay
       ======================================== */
    .modal-overlay {
        position: fixed;
        inset: 0;
        z-index: 50;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding: 0;
    }

    @media (min-width: 768px) {
        .modal-overlay {
            align-items: center;
            padding: 1rem;
        }
    }

    /* ========================================
       Modal Container
       ======================================== */
    .modal-container {
        background: var(--bg-primary);
        width: 100%;
        max-width: 100%;
        height: 100vh;
        max-height: 100vh;
        display: flex;
        flex-direction: column;
        border-radius: var(--radius) var(--radius) 0 0;
        box-shadow: var(--shadow);
        overflow: hidden;
    }

    @media (min-width: 768px) {
        .modal-container {
            max-width: 100%;
            height: auto;
            max-height: 100vh;
            border-radius: var(--radius);
        }
    }

    @media (min-width: 1024px) {
        .modal-container {
            max-width: 100%;
        }
    }

    /* ========================================
       Modal Header
       ======================================== */
    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 1.25rem;
        border-bottom: 1px solid var(--border);
        background: var(--bg-secondary);
        flex-shrink: 0;
    }

    .head-main {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        min-width: 0;
        flex: 1;
    }

    .head-icon {
        height: 34px;
        width: 34px;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--radius-sm);
        font-size: 1.05rem;
        color: #845ADF;
        background: rgba(132, 90, 223, 0.10);
    }

    .header-content { min-width: 0; }

    .modal-title {
        font-size: 1rem;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .modal-subtitle {
        font-size: 0.75rem;
        color: var(--text-muted);
        margin: 0.125rem 0 0;
    }

    .btn-close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.5rem;
        height: 2.5rem;
        border: none;
        background: var(--bg-secondary);
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.2s;
        margin-left: 1rem;
    }

    .btn-close:hover {
        background: var(--danger-light);
        color: var(--danger);
    }

    .btn-close svg {
        width: 1.25rem;
        height: 1.25rem;
    }

    /* ========================================
       Alerts
       ======================================== */
    .alert {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.875rem 1.25rem;
        margin: 0.75rem 1.25rem;
        border-radius: var(--radius-sm);
        font-size: 0.875rem;
        font-weight: 500;
    }

    .alert-success {
        background: var(--success-light);
        color: #065f46;
        border: 1px solid #a7f3d0;
    }

    .alert-error {
        background: var(--danger-light);
        color: #991b1b;
        border: 1px solid #fecaca;
    }

    .alert-icon {
        width: 1.25rem;
        height: 1.25rem;
        flex-shrink: 0;
    }

    /* ========================================
       Tabs Navigation
       ======================================== */
    .tabs-navigation {
        background: var(--bg-secondary);
        border-bottom: 1px solid var(--border);
        flex-shrink: 0;
    }

    .tabs-scroll {
        display: flex;
        overflow-x: auto;
        scrollbar-width: none;
        padding: 0 0.5rem;
        gap: 0.25rem;
    }

    .tabs-scroll::-webkit-scrollbar { display: none; }

    .tab-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.25rem;
        padding: 0.75rem 0.75rem;
        border: none;
        background: transparent;
        cursor: pointer;
        white-space: nowrap;
        transition: all 0.2s;
        color: var(--text-secondary);
        min-width: 60px;
        position: relative;
    }

    @media (min-width: 768px) {
        .tab-btn {
            flex-direction: row;
            gap: 0.5rem;
            padding: 0.875rem 1rem;
            min-width: auto;
        }
    }

    .tab-btn { font-weight: 600; }

    .tab-btn:hover {
        color: var(--primary);
        background: rgba(132, 90, 223, 0.06);
    }

    .tab-btn.active {
        color: var(--primary);
        background: rgba(132, 90, 223, 0.08);
    }

    .tab-btn.active::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: var(--primary);
    }

    .tab-icon { font-size: 1.05rem; }

    .tab-label {
        font-size: 0.6875rem;
        font-weight: 600;
    }

    @media (min-width: 768px) {
        .tab-label { font-size: 0.8125rem; }
    }

    /* ========================================
       Modal Body
       ======================================== */
    .modal-body {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 1.25rem;
        background: var(--bg-secondary);
    }

    .tab-content {
        animation: fadeIn 0.2s ease-out;
    }

    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
    }

    /* ========================================
       Info Banner
       ======================================== */
    .info-banner {
        display: flex;
        align-items: flex-start;
        gap: 0.75rem;
        padding: 1rem;
        background: #eff6ff;
        border-radius: var(--radius-sm);
        margin-bottom: 1.5rem;
        border: 1px solid #bfdbfe;
    }

    .info-icon {
        width: 1.25rem;
        height: 1.25rem;
        color: var(--primary);
        flex-shrink: 0;
    }

    .info-banner p {
        font-size: 0.8125rem;
        color: #1e40af;
        line-height: 1.5;
        margin: 0;
    }

    /* ========================================
       Form Sections
       ======================================== */
    .form-section {
        background: var(--bg-primary);
        border-radius: var(--radius);
        padding: 1.25rem;
        margin-bottom: 1rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        border: 1px solid var(--border);
    }

    .section-title {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.9375rem;
        font-weight: 600;
        color: var(--text-primary);
        margin: 0 0 1.25rem;
        padding-bottom: 0.75rem;
        border-bottom: 1px solid var(--border);
    }

    .section-icon { font-size: 1.125rem; }

    /* ========================================
       Form Elements
       ======================================== */
    .form-row {
        display: grid;
        grid-template-columns: 1fr;
        gap: 1rem;
        margin-bottom: 1rem;
    }

    @media (min-width: 640px) {
        .form-row { grid-template-columns: repeat(2, 1fr); }
    }

    .form-row-3 {
        grid-template-columns: 1fr;
    }

    @media (min-width: 768px) {
        .form-row-3 { grid-template-columns: repeat(3, 1fr); }
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        margin-bottom: 1rem;
    }

    .form-label {
        font-size: 0.72rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        color: var(--text-secondary);
    }

    .form-label.required::after {
        content: " *";
        color: var(--danger);
    }

    .form-input,
    .form-select {
        width: 100%;
        height: 2.5rem;
        padding: 0 0.75rem;
        font-size: 0.82rem;
        border: 1px solid var(--border);
        border-radius: var(--radius-sm);
        background: var(--bg-primary);
        color: var(--text-primary);
        transition: border-color 0.2s, box-shadow 0.2s;
        outline: none;
    }

    .form-input:focus,
    .form-select:focus {
        border-color: var(--primary);
        box-shadow: 0 0 0 3px rgba(132, 90, 223, 0.12);
    }

    .form-input:disabled,
    .form-select:disabled {
        background: var(--bg-tertiary);
        color: var(--text-muted);
        cursor: not-allowed;
    }

    .form-input::placeholder {
        color: var(--text-muted);
    }

    /* Select Wrapper */
    .select-wrapper {
        position: relative;
    }

    .select-wrapper .form-select {
        appearance: none;
        padding-right: 2.5rem;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 0.75rem center;
    }

    /* Input with Action */
    .input-action-group {
        display: flex;
        gap: 0.5rem;
    }

    .input-action-group .form-input { flex: 1; }

    .btn-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.75rem;
        border: 1px solid var(--primary);
        background: var(--primary);
        color: white;
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.2s;
        flex-shrink: 0;
    }

    .btn-icon:hover:not(:disabled) { background: var(--primary-hover); }

    .btn-icon:disabled {
        background: var(--bg-tertiary);
        border-color: var(--border);
        color: var(--text-muted);
        cursor: not-allowed;
    }

    .btn-icon svg {
        width: 1.125rem;
        height: 1.125rem;
    }

    /* Currency Input */
    .input-currency {
        position: relative;
    }

    .input-currency .form-input { padding-right: 3.5rem; }

    .currency {
        position: absolute;
        right: 0.875rem;
        top: 50%;
        transform: translateY(-50%);
        font-size: 0.75rem;
        font-weight: 600;
        color: var(--text-muted);
    }

    /* Toggle Button */
    .toggle-container { display: flex; }

    .toggle-btn {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.5rem;
        border: none;
        background: transparent;
        cursor: pointer;
        border-radius: var(--radius-sm);
        transition: all 0.2s;
    }

    .toggle-btn:hover:not(:disabled) { background: var(--bg-tertiary); }

    .toggle-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .toggle-track {
        position: relative;
        width: 2.75rem;
        height: 1.5rem;
        background: var(--bg-tertiary);
        border-radius: 1rem;
        border: 1px solid var(--border);
        transition: all 0.2s;
    }

    .toggle-btn.active .toggle-track {
        background: var(--success);
        border-color: var(--success);
    }

    .toggle-btn.warning.active .toggle-track {
        background: var(--warning);
        border-color: var(--warning);
    }

    .toggle-thumb {
        position: absolute;
        top: 2px;
        left: 2px;
        width: 1.125rem;
        height: 1.125rem;
        background: white;
        border-radius: 50%;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        transition: all 0.2s;
    }

    .toggle-btn.active .toggle-thumb { left: calc(100% - 1.375rem); }

    .toggle-text {
        font-size: 0.8125rem;
        font-weight: 500;
        color: var(--text-secondary);
    }

    /* Radio Group */
    .radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
    }

    .radio-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        cursor: pointer;
        font-size: 0.8125rem;
        color: var(--text-secondary);
    }

    .radio-item input { display: none; }

    .radio-mark {
        width: 1.125rem;
        height: 1.125rem;
        border: 2px solid var(--border);
        border-radius: 50%;
        position: relative;
        transition: all 0.2s;
    }

    .radio-item input:checked + .radio-mark { border-color: var(--primary); }

    .radio-item input:checked + .radio-mark::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0.5rem;
        height: 0.5rem;
        background: var(--primary);
        border-radius: 50%;
    }

    /* Chip Group */
    .chip-group {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
    }

    .chip {
        padding: 0.5rem 1rem;
        font-size: 0.8125rem;
        font-weight: 500;
        border: 1px solid var(--border);
        background: var(--bg-primary);
        color: var(--text-secondary);
        border-radius: 2rem;
        cursor: pointer;
        transition: all 0.2s;
    }

    .chip:hover {
        border-color: var(--primary);
        color: var(--primary);
    }

    .chip.active {
        background: var(--primary);
        border-color: var(--primary);
        color: white;
    }

    /* ========================================
       Table Styles
       ======================================== */
    .table-wrapper {
        background: var(--bg-primary);
        border-radius: var(--radius);
        overflow: hidden;
        border: 1px solid var(--border);
    }

    .table-scroll {
        overflow-x: auto;
        max-height: 400px;
        overflow-y: auto;
    }

    .data-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.8125rem;
    }

    .data-table th {
        position: sticky;
        top: 0;
        background: var(--bg-tertiary);
        padding: 0.75rem;
        text-align: left;
        font-weight: 600;
        color: var(--text-primary);
        border-bottom: 1px solid var(--border);
        white-space: nowrap;
    }

    .data-table td {
        padding: 0.75rem;
        border-bottom: 1px solid var(--border);
        vertical-align: middle;
    }

    .data-table tr:hover { background: var(--bg-secondary); }

    .data-table .row-new { background: #fef9c3; }

    .sticky-col {
        position: sticky;
        left: 0;
        background: inherit;
        z-index: 1;
    }

    .cell-entrepot {
        font-weight: 600;
        color: var(--text-primary);
    }

    .cell-value { color: var(--text-secondary); }

    .table-input {
        width: 80px;
        padding: 0.375rem 0.5rem;
        font-size: 0.8125rem;
        border: 1px solid var(--border);
        border-radius: 4px;
        background: var(--bg-primary);
        text-align: right;
    }

    .table-input:focus {
        outline: none;
        border-color: var(--primary);
        box-shadow: 0 0 0 2px var(--primary-light);
    }

    .table-input.highlight {
        background: #fef3c7;
        border-color: var(--warning);
    }

    .btn-tarif {
        display: flex;
        align-items: center;
        gap: 0.375rem;
        padding: 0.375rem 0.75rem;
        font-size: 0.75rem;
        font-weight: 500;
        border: 1px solid var(--primary);
        background: var(--primary-light);
        color: var(--primary);
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.2s;
    }

    .btn-tarif:hover {
        background: var(--primary);
        color: white;
    }

    .btn-tarif svg {
        width: 0.875rem;
        height: 0.875rem;
    }

    /* Tarif list */
    .tarif-list {
        display: flex;
        flex-direction: column;
        gap: 4px;
        margin-bottom: 6px;
    }

    .tarif-row {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 3px 6px;
        background: var(--gray-50);
        border-radius: 4px;
        font-size: 0.6875rem;
        white-space: nowrap;
    }

    .tarif-label {
        font-weight: 600;
        color: var(--primary);
        min-width: 28px;
    }

    .tarif-price {
        color: var(--gray-700);
        font-weight: 500;
    }

    .tarif-range {
        color: var(--gray-500);
        font-size: 0.625rem;
    }

    .tarif-delete {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.25rem;
        height: 1.25rem;
        margin-left: auto;
        border: none;
        background: transparent;
        color: var(--gray-400);
        cursor: pointer;
        border-radius: 3px;
        transition: all 0.15s;
        flex-shrink: 0;
    }

    .tarif-delete:hover {
        background: #fee2e2;
        color: #ef4444;
    }

    .tarif-delete svg {
        width: 0.75rem;
        height: 0.75rem;
    }

    .tarif-empty {
        font-size: 0.6875rem;
        color: var(--gray-400);
        font-style: italic;
        padding: 2px 6px;
    }

    .tarif-add {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        width: 100%;
        padding: 4px 8px;
        font-size: 0.6875rem;
        font-weight: 500;
        border: 1px dashed var(--primary);
        background: transparent;
        color: var(--primary);
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.2s;
    }

    .tarif-add:hover {
        background: var(--primary-light);
        border-style: solid;
    }

    .tarif-add svg {
        width: 0.75rem;
        height: 0.75rem;
    }

    /* Checkbox */
    .checkbox-wrapper {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        cursor: pointer;
    }

    .checkbox-wrapper input { display: none; }

    .checkmark {
        width: 1.125rem;
        height: 1.125rem;
        border: 2px solid var(--border);
        border-radius: 4px;
        position: relative;
        transition: all 0.2s;
    }

    .checkbox-wrapper input:checked + .checkmark {
        background: var(--primary);
        border-color: var(--primary);
    }

    .checkbox-wrapper input:checked + .checkmark::after {
        content: "";
        position: absolute;
        top: 2px;
        left: 5px;
        width: 4px;
        height: 8px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

    .checkbox-wrapper input:disabled + .checkmark {
        background: var(--bg-tertiary);
        cursor: not-allowed;
    }

    .checkbox-text {
        font-size: 0.6875rem;
        color: var(--text-muted);
    }

    /* Empty State */
    .empty-cell { text-align: center; }

    .empty-state {
        padding: 2rem;
        color: var(--text-muted);
    }

    .empty-state svg {
        width: 3rem;
        height: 3rem;
        margin-bottom: 0.75rem;
        opacity: 0.5;
    }

    .empty-state p {
        margin: 0;
        font-size: 0.875rem;
    }

    /* ========================================
       Accompagnement Section
       ======================================== */
    .accompagnement-add {
        display: flex;
        gap: 0.75rem;
        margin-bottom: 1rem;
    }

    .accompagnement-add .select-wrapper { flex: 1; }

    .btn-add {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.625rem 1rem;
        font-size: 0.875rem;
        font-weight: 500;
        border: none;
        background: var(--primary);
        color: white;
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.2s;
        white-space: nowrap;
    }

    .btn-add:hover { background: var(--primary-hover); }

    .btn-add svg {
        width: 1rem;
        height: 1rem;
    }

    .accompagnement-list {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .accompagnement-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.75rem 1rem;
        background: var(--bg-secondary);
        border-radius: var(--radius-sm);
        margin-bottom: 0.5rem;
        border: 1px solid var(--border);
    }

    .accompagnement-name {
        font-size: 0.875rem;
        font-weight: 500;
        color: var(--text-primary);
    }

    .btn-remove {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        border: none;
        background: var(--danger-light);
        color: var(--danger);
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.2s;
    }

    .btn-remove:hover { background: var(--danger); color: white; }

    .btn-remove svg {
        width: 1rem;
        height: 1rem;
    }

    .empty-accompagnement {
        text-align: center;
        padding: 2rem;
        color: var(--text-muted);
    }

    .empty-accompagnement svg {
        width: 3rem;
        height: 3rem;
        margin-bottom: 0.75rem;
        opacity: 0.5;
    }

    .empty-accompagnement p {
        margin: 0;
        font-size: 0.875rem;
    }

    /* ========================================
       Modal Footer
       ======================================== */
    .modal-footer {
        display: flex;
        justify-content: flex-end;
        gap: 0.75rem;
        padding: 1rem 1.25rem;
        border-top: 1px solid var(--border);
        background: var(--bg-primary);
        flex-shrink: 0;
    }

    .btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.625rem 1.25rem;
        font-size: 0.875rem;
        font-weight: 500;
        border: none;
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.2s;
    }

    .btn svg {
        width: 1.125rem;
        height: 1.125rem;
    }

    .btn-cancel {
        background: var(--bg-tertiary);
        color: var(--text-secondary);
    }

    .btn-cancel:hover { background: var(--danger-light); color: var(--danger); }

    .btn-save {
        background: var(--success);
        color: white;
    }

    .btn-save:hover { background: #059669; }

    /* ========================================
       Animations
       ======================================== */
    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: all 0.3s ease;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter .modal-container,
    .modal-fade-leave-to .modal-container {
        transform: translateY(100px);
    }

    @media (min-width: 768px) {
        .modal-fade-enter .modal-container,
        .modal-fade-leave-to .modal-container {
            transform: scale(0.95) translateY(20px);
        }
    }

    /* Utility */
    .flex-grow { flex: 1; }



    ::-webkit-scrollbar{ /* pour gerer l'aperçu du scroll  */
        height: 20px;
        width: 0px;
        --tw-bg-opacity: 1;
        background-color: rgb(249 250 251 / var(--tw-bg-opacity));
    }
</style>